import { PessoaListaRequest } from "./pessoa-lista.request";

// Baseada no uso no Controller: PostValidar recebe ImportarArquivoRequest
export class ImportarArquivoRequest {
    public arquivoBase64: string = '';
}